/**
 * Calender content module
 *
 * @module Calendar
 * @author EN GARDE (Reinhold Seiss)
 * @version 1.0
 */

var EN = EN || {};

EN.Calendar = (function ($) {
	'use strict';

	var options = {
		selectors: {
			// calendarDateSmallWithOffset: '.en-calendar__date-small--offset',
			// calendarDateSmallNoOffset: '.en-calendar__date-small--no-offset'
			calendarDateSmall: '.en-calendar__date-small'
		}
	};

	/**
	 * Initializes Calendar component and sets listeners for animations.
	 * @memberof module:Calendar
	 */
	var init = function () {
		// Make calendar date on mobile stick to the top
		// $(options.selectors.calendarDateSmallWithOffset).stickybits({
		// 	useStickyClasses: true,
		// 	stickyBitStickyOffset: 44
		// });

		// $(options.selectors.calendarDateSmallNoOffset).stickybits({
		// 	useStickyClasses: true
		// });

		// $(options.selectors.calendarDateSmall).stickybits({
		// 	useStickyClasses: true,
		// 	stickyBitStickyOffset: 44,
		// });
	};

	// exports
	return {
		init: init
	};
}(jQuery));
